import connect from '../axios/axios.auth';

const functions =  {
  register: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/productos/registrar/`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  listado: () => {
    return new Promise((resolve, reject) => {
        connect.get(`/productos/`)
        .then((response) => {
          resolve(response.data)
        })
      })
  },
  update: (data) => {
    return new Promise((resolve, reject) => {
        connect.post(`/productos/modificar/`, data)
        .then((response) => {
          resolve(response.data)
        })
      })
  }
}

export default functions;